export interface GoogleLogoProps {
  className?: string;
}

const GoogleLogo = ({ className }: GoogleLogoProps) => {
  return (
    <svg
      viewBox="0 0 75 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g clipPath="url(#clip0_3052_3084)">
        <path
          d="M31.9537 12.8206C31.9537 16.2907 29.239 18.8478 25.9075 18.8478C22.576 18.8478 19.8613 16.2907 19.8613 12.8206C19.8613 9.32607 22.576 6.79346 25.9075 6.79346C29.239 6.79346 31.9537 9.32607 31.9537 12.8206ZM29.307 12.8206C29.307 10.6522 27.7336 9.16846 25.9075 9.16846C24.0814 9.16846 22.5081 10.6522 22.5081 12.8206C22.5081 14.9674 24.0814 16.4728 25.9075 16.4728C27.7336 16.4728 29.307 14.9647 29.307 12.8206Z"
          fill="white"
        />
        <path
          d="M44.9977 12.8208C44.9977 16.2909 42.283 18.8479 38.9515 18.8479C35.6199 18.8479 32.9053 16.2909 32.9053 12.8208C32.9053 9.32891 35.6199 6.79358 38.9515 6.79358C42.283 6.79358 44.9977 9.32619 44.9977 12.8208ZM42.3509 12.8208C42.3509 10.6523 40.7776 9.16858 38.9515 9.16858C37.1254 9.16858 35.552 10.6523 35.552 12.8208C35.552 14.9675 37.1254 16.4729 38.9515 16.4729C40.7776 16.4729 42.3509 14.9648 42.3509 12.8208Z"
          fill="white"
        />
        <path
          d="M57.4977 7.15771V17.9784C57.4977 22.4295 54.8727 24.2474 51.7694 24.2474C48.8483 24.2474 47.0901 22.2936 46.4271 20.6958L48.7314 19.7365C49.1417 20.7175 50.1472 21.8751 51.7667 21.8751C53.7531 21.8751 54.9841 20.6496 54.9841 18.3425V17.4756H54.8917C54.2993 18.2066 53.158 18.8452 51.7178 18.8452C48.7042 18.8452 45.9434 16.2202 45.9434 12.8425C45.9434 9.44032 48.7042 6.79358 51.7178 6.79358C53.1553 6.79358 54.2966 7.43217 54.8917 8.14141H54.9841V7.16043H57.4977V7.15771ZM55.1716 12.8425C55.1716 10.7202 53.7559 9.16858 51.9542 9.16858C50.1281 9.16858 48.5983 10.7202 48.5983 12.8425C48.5983 14.943 50.1281 16.4729 51.9542 16.4729C53.7559 16.4729 55.1716 14.943 55.1716 12.8425Z"
          fill="white"
        />
        <path
          d="M61.6411 0.814941V18.478H59.0596V0.814941H61.6411Z"
          fill="white"
        />
        <path
          d="M71.7013 14.8046L73.7556 16.1742C73.0926 17.1551 71.4948 18.8454 68.7339 18.8454C65.31 18.8454 62.7529 16.1986 62.7529 12.8182C62.7529 9.23395 65.3317 6.79102 68.4377 6.79102C71.5654 6.79102 73.0953 9.28015 73.5953 10.6253L73.8698 11.31L65.8127 14.647C66.4296 15.8562 67.3888 16.4731 68.7339 16.4731C70.0817 16.4731 71.0165 15.81 71.7013 14.8046ZM65.3779 12.6361L70.7638 10.3997C70.4676 9.64699 69.5763 9.12254 68.5274 9.12254C67.1823 9.12254 65.31 10.31 65.3779 12.6361Z"
          fill="white"
        />
        <path
          d="M10.0895 11.2529V8.69586H18.7064C18.7906 9.14152 18.8341 9.66869 18.8341 10.2393C18.8341 12.1578 18.3096 14.5301 16.6194 16.2203C14.9754 17.9323 12.8748 18.8453 10.0922 18.8453C4.93461 18.8453 0.597656 14.6442 0.597656 9.48662C0.597656 4.32902 4.93461 0.12793 10.0922 0.12793C12.9455 0.12793 14.9781 1.24749 16.5053 2.70673L14.7009 4.51108C13.6058 3.48391 12.1221 2.68499 10.0895 2.68499C6.3232 2.68499 3.37755 5.72032 3.37755 9.48662C3.37755 13.2529 6.3232 16.2883 10.0895 16.2883C12.5324 16.2883 13.9237 15.3073 14.815 14.416C15.5379 13.6931 16.0134 12.6605 16.2009 11.2502L10.0895 11.2529Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_3052_3084">
          <rect
            width="73.913"
            height="25"
            fill="white"
            transform="translate(0.5)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
export default GoogleLogo;
